export default {
  dashboard: () => import("/codebuild/output/src1962478339/src/kichieats-front/layouts/dashboard.vue"),
  error: () => import("/codebuild/output/src1962478339/src/kichieats-front/layouts/error.vue"),
  "login-admin": () => import("/codebuild/output/src1962478339/src/kichieats-front/layouts/login-admin.vue"),
  login: () => import("/codebuild/output/src1962478339/src/kichieats-front/layouts/login.vue"),
  owner: () => import("/codebuild/output/src1962478339/src/kichieats-front/layouts/owner.vue")
}